import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, Loader2 } from "lucide-react";
import { Switch } from "../../ui/switch";
import { api, errMsg } from "../../../lib/api";
import { BALANCE_EVENT } from "./RechargeBanner";

export const AlertSettings = ({ e, onSaved }) => {
  const [f, setF] = useState({ low_threshold: e.low_threshold, pause_at_zero: e.pause_at_zero });
  const [busy, setBusy] = useState(false);
  useEffect(() => { setF({ low_threshold: e.low_threshold, pause_at_zero: e.pause_at_zero }); }, [e.low_threshold, e.pause_at_zero]);
  const dirty = Number(f.low_threshold) !== e.low_threshold || f.pause_at_zero !== e.pause_at_zero;

  const save = async () => {
    setBusy(true);
    try {
      await api.adminSaveAlerts({ low_threshold: Number(f.low_threshold), pause_at_zero: f.pause_at_zero });
      toast.success("Alert settings saved"); window.dispatchEvent(new Event(BALANCE_EVENT)); onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 sm:p-6 space-y-4" data-testid="alert-settings">
      <div className="flex items-center gap-2"><BellRing size={16} className="text-rose-500" /><h2 className="text-lg font-semibold text-slate-900">Recharge alert</h2></div>
      <p className="text-sm text-slate-500 -mt-2">A red banner appears at the top of your admin panel when your estimated Emergent balance drops below this.</p>
      <label className="flex flex-wrap items-center gap-3 text-sm text-slate-700">Alert me when fewer than
        <input type="number" min={0} step={1} value={f.low_threshold} onChange={(ev) => setF({ ...f, low_threshold: ev.target.value })} data-testid="alert-threshold-input"
          className="w-28 h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 font-mono text-slate-900 outline-none focus:border-sky-400 focus:bg-white" />
        credits are left
      </label>
      <label className="flex items-start gap-3 cursor-pointer">
        <Switch checked={f.pause_at_zero} onCheckedChange={(v) => setF({ ...f, pause_at_zero: v })} data-testid="alert-pause-switch" className="mt-0.5" />
        <span className="text-sm text-slate-700">Pause customer builds when the balance reaches zero
          <span className="block text-xs text-slate-500">When off, builds keep running and you only see the alert. You can always build yourself.</span></span>
      </label>
      {!e.tracking && <p className="text-xs text-amber-700 bg-amber-50 rounded-lg px-3 py-2" data-testid="alert-not-tracking">Record your first Emergent recharge below to start tracking — alerts and pausing only work after that.</p>}
      <button onClick={save} disabled={!dirty || busy || f.low_threshold === ""} data-testid="alert-settings-save"
        className="h-9 px-5 rounded-full bg-slate-900 text-white text-sm font-semibold flex items-center gap-2 hover:bg-slate-700 disabled:opacity-40 transition-colors">
        {busy && <Loader2 size={14} className="animate-spin" />} Save
      </button>
    </section>
  );
};

export default AlertSettings;
